import { Observable } from 'rxjs';

import { NotebookSidebarPreference } from '../notebook-sidebar.types';
import { OrgTypes } from '@mode/shared/contract-common';
import { NotebookType } from '../notebook.types';
import { SessionResource } from './notebook.types';

export abstract class NotebookFacade {
  abstract notebookToken$: Observable<string>;
  abstract notebookType$: Observable<any>;
  abstract accountPreference$: Observable<any>;
  abstract accountContextPlanCode$: Observable<OrgTypes.PlanCode>;
  abstract selectedNotebookSession$: Observable<SessionResource>;
  abstract selectedReportReportRunStateSelector$: Observable<any>; // TODO: change to ReportRunResource belongs to report legacy contract
  abstract updatePreference(preference: NotebookSidebarPreference): void;
  abstract updateNotebookType(notebookToken: string, notebookType: NotebookType): void;
  abstract createNotebook(reportToken: string): void;
  abstract initSession(notebookToken: string, reuseIfActive: boolean, runNewCells?: boolean): void;
  abstract clearAllCellOutputs(notebookToken: string): void;
  abstract cancelRun(notebookToken: string): void;
  abstract runNotebook(notebookToken: string, cellTokensToRun?: string[]): void;
  abstract refreshSessionReportRun(notebookToken: string): void;
  abstract toggleNotebookSidebar(): void;
  abstract initNotebook(): void;
  abstract addNotebook(reportToken: string): void;
  abstract importNotebook(file: File, reportToken?: string): void;
}
